var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-edit",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M244.765162 738.241072l-37.631859 75.263717 75.263718-37.631859L883.226768 185.603144a34.047872 34.047872 0 0 0-48.575818-47.807821l-589.821788 600.317749zM64.02984 1020.608013A63.99976 63.99976 0 0 1 6.750055 928.00036l127.99952-255.99904c3.007989-6.015977 7.039974-11.519957 11.647956-16.255939l597.30976-607.99772A162.303391 162.303391 0 0 1 973.27443 47.363662a162.303391 162.303391 0 0 1 0 229.119141l-608.381718 597.757759c-4.799982 4.671982-10.239962 8.639968-16.255939 11.647956l-255.99904 127.99952a63.99976 63.99976 0 0 1-28.607893 6.719975z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3d025cf43617d2c1ae953ec047cfbcc8.svg";
export { ForwardRef as ReactComponent };